export default {
  guide: {
    start: 'Comenzar',
    whatsNext: '¿Qué sigue?',
    dontShowAgain: 'No volver a mostrar esta ventana emergente',
    needHelp: '¿Necesitas ayuda?',
    userManual: 'Manual de usuario',
    chooseFormat: 'Elige tu formato preferido',
    pdfManual: 'Manual en PDF',
    downloadPdf: 'Descargar y leer sin conexión',
    videoTutorial: 'Tutorial en video',
    watchStepByStep: 'Ver guía paso a paso',
    firstStepTitle: '¡Bienvenido! Te guiaremos a través de tus primeros pasos.',
    activationKey: {
      title: 'Las nuevas claves de activación se han registrado correctamente.',
      description:
        'Envía las claves de activación a los agricultores/recolectores de datos para que puedan registrarse bajo tu organización.',
      nextStep: 'Haz clic en el botón Acción para seleccionar el formato en el que deseas compartir las claves.',
    },
    dashboard: {
      userManagement: 'Gestión de usuarios',
      userManagementDescription: 'La sección de Gestión de usuarios te permite:',
      listUser: 'Ver la lista actual de usuarios móviles y administradores',
      addUser: 'Agregar nuevos usuarios o invitar usuarios con claves de activación',
      managePermission: 'Gestionar permisos, planes de membresía y roles',
      farmManagement: 'Gestión de fincas',
      farmManagementDescription: 'Ve a la sección de Gestión de fincas para:',
      listFarm: 'Ver la lista de fincas y agricultores registrados',
      addFarm: 'Agregar nuevas fincas una por una o en bloque',
      title: 'Panel de control',
      description:
        'A medida que incorpores más usuarios y fincas, podrás ver el resumen en el panel de control principal.',
    },
    ddsDashboard: {
      title: 'Comienza con la sección “Crear nuevo informe de diligencia debida” para empezar.',
      alreadyHaveFarm: '¿Ya tienes datos de la finca?',
      description:
        'Tendrás la opción de agregar los datos de tu finca durante el segundo paso del proceso "Crear nuevo informe de diligencia debida".',
      createNewReport: 'Crear nuevo informe',
      creatingReport: 'Creando un informe de diligencia debida',
      sharingWithOperator: 'Compartiendo con el operador',
      riskMitigation: 'Mitigación de riesgos',
    },
    productionPlace: {
      title: 'Sube los datos de tu finca',
      description: 'Sube los datos de tu finca uno por uno o en bloque haciendo clic en el botón "Agregar nuevo".',
      allowedFormat: 'Actualmente aceptamos los siguientes formatos para la carga masiva de datos:',
    },
    reportDetail: {
      title: 'Primero, completa los detalles relacionados con tu informe.',
      description: '¿Necesitas ayuda? Consulta nuestras guías de usuario (PDF o video) haciendo clic aquí:',
      nextStep:
        'Una vez finalizado, haz clic en "Siguiente" para continuar al paso donde podrás subir los datos de producción de tu finca.',
    },
    adminRegistered: {
      title: 'El nuevo usuario administrador se ha registrado correctamente.',
      description:
        'Envía las claves de activación a los agricultores/recolectores de datos para que puedan registrarse bajo tu organización.',
      nextStep: '¿Qué sigue? Comienza a incorporar agricultores y recolectores de datos.',
    },
  },
};
